import { render } from "./companyDoc.vue?vue&type=template&id=2ec0dd05&scoped=true"
import script from "./companyDoc.vue?vue&type=script&lang=js"
export * from "./companyDoc.vue?vue&type=script&lang=js"

import "./companyDoc.vue?vue&type=style&index=0&id=2ec0dd05&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec0dd05"]])

export default __exports__